import { c as _c } from "react/compiler-runtime";
import { TOP_NAV_DATA_GA, TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { Link } from '@/app/components/navigation/link';
import type { MenuLinkType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
interface ItemLinkProps extends MenuLinkType {
  isActiveVehicle?: boolean;
  className?: string;
}
export const Item = t0 => {
  const $ = _c(21);
  let className;
  let href;
  let isActiveVehicle;
  let label;
  let rest;
  let target;
  if ($[0] !== t0) {
    ({
      href,
      target,
      label,
      isActiveVehicle,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = href;
    $[3] = isActiveVehicle;
    $[4] = label;
    $[5] = rest;
    $[6] = target;
  } else {
    className = $[1];
    href = $[2];
    isActiveVehicle = $[3];
    label = $[4];
    rest = $[5];
    target = $[6];
  }
  const activeVehicleClassName = cn("font-noto-bold relative justify-center", "after:absolute after:bottom-0 after:border-6 after:border-t-0 after:border-b-6 after:border-transparent after:border-b-white");
  const t1 = isActiveVehicle ? "/" : href;
  const t2 = isActiveVehicle ? "_self" : target;
  let t3;
  if ($[7] !== className || $[8] !== isActiveVehicle) {
    t3 = cn("transition-color flex h-full items-center outline-none hover:text-gray-300 focus-visible:text-gray-300", {
      [activeVehicleClassName]: isActiveVehicle
    }, className);
    $[7] = className;
    $[8] = isActiveVehicle;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: TOP_NAV_DATA_TEST.navigationMenuLink
    });
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isActiveVehicle ? "/" : href;
  let t6;
  if ($[11] !== label || $[12] !== t5) {
    t6 = createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.buyingTools,
      url: t5,
      text: label
    });
    $[11] = label;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== label || $[15] !== rest || $[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t6) {
    t7 = <Link {...rest} href={t1} target={t2} role="menuitem" className={t3} {...t4} {...t6}>{label}</Link>;
    $[14] = label;
    $[15] = rest;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};